export const getAppUrl = (): string => {
  if (import.meta.env.VITE_USE_CURRENT_ORIGIN === "true" && typeof window !== "undefined") {
    return window.location.origin;
  }

  const appUrl = import.meta.env.VITE_APP_URL;
  if (appUrl) {
    return appUrl;
  }
  // Fallback to current origin in browser, or a sensible default
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "https://app.forgehq.io";
};

import {
  buildTenantAppUrlFromSlug,
  getTenantSlugFromHost,
  isTenantHost,
} from "./tenant-domain";

const getActiveHost = (): string => {
  if (typeof window === "undefined") {
    return getAppHost();
  }

  return window.location.hostname;
};

export const getAppHost = (): string => new URL(getAppUrl()).host;

export const getTenantAwareAppHost = (): string => {
  const hostname = getActiveHost();
  const tenantSlug = getTenantSlugFromHost(hostname);
  if (tenantSlug) {
    return new URL(buildTenantAppUrlFromSlug(tenantSlug)).host;
  }
  return getAppHost();
};

export const buildOrganizationDisplayUrl = (slug: string): string => {
  if (!slug) {
    return getTenantAwareAppHost();
  }

  if (isTenantHost(getActiveHost())) {
    try {
      return buildTenantAppUrlFromSlug(slug);
    } catch {
      return `https://${getTenantAwareAppHost()}/${slug}`;
    }
  }

  return `https://${getAppHost()}/${slug}`;
};
